// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Shop } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  marketplace: Shop
};

// ==============================|| MENU ITEMS - DEVELOPMENT ||============================== //

const development: NavItemType = {
  id: 'marketplace-group',
  title: <FormattedMessage id="marketplace.title" />,
  type: 'group',
  children: [
    {
      id: 'marketplace',
      title: <FormattedMessage id="marketplace.title" />,
      type: 'item',
      url: '/marketplace',
      icon: icons.marketplace
    }
    // {
    //   id: 'account',
    //   title: 'Cuenta',
    //   type: 'collapse',
    //   icon: icons.account,
    //   children: [
    //     {
    //       id: 'user',
    //       title: 'Mi perfil',
    //       type: 'item',
    //       url: '/account',
    //       icon: icons.user
    //     },
    //     {
    //       id: 'payment',
    //       title: 'Método de pago',
    //       type: 'item',
    //       url: '/account/payment',
    //       icon: icons.payment
    //     }
    //   ]
    // }
  ]
};

export default development;
